module.exports = __webpack_public_path__ + "img/website_dev.bf2655b4.png";